// Compiled at 2026-09-18T12:45:23.821Z
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty, jsonArrayProperty, AnyType } from "@sumbricht/json-class-serializer";
import { BoInfoSymbol } from "@lg/shared/for-apps";
import { computed, isSignal } from "../../signals.js";
import { Signals, HasSignalProperties } from "@lg/shared/for-apps";
import { equal } from "@lg/shared/for-apps";
import { immerable } from "immer";
import { untracked } from "@angular/core";
@jsonClass('Orders.CustomerOffer')
class Orders__CustomerOffer {
    @jsonProperty(() => Orders__CustomerOffer.Id)
    id: Orders__CustomerOffer.Id;
    static readonly [BoInfoSymbol] = Object.freeze({
        boType: "Entity" as const,
        idType: "number" as const,
        editablePropertyNames: unwrapReadonly(Object.freeze(["id", "customerShippingFees", "targetMarginPercentage", "targetDeliveryTimeWeeks", "currency", "currency$id", "offerFilename", "emailText", "request", "requestId", "items", "offerFile", "offerFileId", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        computedPropertyNames: unwrapReadonly(Object.freeze([] as const)),
        allPropertyNames: unwrapReadonly(Object.freeze(["id", "customerShippingFees", "targetMarginPercentage", "targetDeliveryTimeWeeks", "currency", "currency$id", "offerFilename", "emailText", "request", "requestId", "items", "offerFile", "offerFileId", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        propertyNamesOfInterest: unwrapReadonly(Object.freeze(["id", "customerShippingFees", "targetMarginPercentage", "targetDeliveryTimeWeeks", "currency", "offerFilename", "emailText", "request", "requestId", "items", "offerFile", "offerFileId", "createdOn", "updatedOn", "deletedOn", "versionNumber"] as const)),
        propertyTypes: unwrapReadonly(Object.freeze({ "customerShippingFees": "number", "targetMarginPercentage": "number", "targetDeliveryTimeWeeks": "number", "currency": "Orders.Currency", "currency$id": "string", "offerFilename": "string", "emailText": "string", "request": "Orders.CustomerRequest", "requestId": "Orders.CustomerRequest.Id", "items": "Orders.CustomerOfferItem[]", "offerFile": "System.BinaryData", "offerFileId": "System.BinaryData.Id", "createdOn": "Date", "createdBy": "System.UserIdAndName", "updatedOn": "Date", "updatedBy": "System.UserIdAndName", "deletedOn": "Date", "deletedBy": "System.UserIdAndName", "versionNumber": "number", "id": "number" } as const)),
        staticEntityProperties: unwrapReadonly(Object.freeze(["currency"] as const)),
        searchInProperties: unwrapReadonly(Object.freeze(["id"] as const)),
        subsetNames: unwrapReadonly(Object.freeze([] as const)),
        manyToOneRelationships: unwrapReadonly(Object.freeze({} as const)),
        oneToManyRelationships: unwrapReadonly(Object.freeze({ items: () => Orders.CustomerOfferItem } as const)),
        oneToOneOwningRelationships: unwrapReadonly(Object.freeze({ request: () => Orders.CustomerRequest, offerFile: () => System.BinaryData } as const)),
        oneToOneSecondaryRelationships: unwrapReadonly(Object.freeze({} as const)),
        embeddedEntities: unwrapReadonly(Object.freeze({} as const)),
        get allRelationships() {
            return {
                ...this.manyToOneRelationships,
                ...this.oneToManyRelationships,
                ...this.oneToOneOwningRelationships,
                ...this.oneToOneSecondaryRelationships,
            } as const
        },
    });
    static readonly Id = Number;
    readonly [HasSignalProperties] = true;
    [immerable] = true;
    private readonly θcustomerShippingFees = Signals.proxySignalDeferred<number>(() => (undefined) as any);
    private readonly θtargetMarginPercentage = Signals.proxySignalDeferred<number>(() => (undefined) as any);
    private readonly θtargetDeliveryTimeWeeks = Signals.proxySignalDeferred<number>(() => (undefined) as any);
    private readonly θcurrency = Signals.proxySignalDeferred<This.Currency>(() => (new This.Currency()) as any);
    private readonly θofferFilename = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θemailText = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θrequest = Signals.proxySignalDeferred<Orders.CustomerRequest>(() => (undefined) as any);
    private readonly θrequestId = Signals.proxySignalDeferred<Orders.CustomerRequest.Id>(() => (undefined) as any);
    private readonly θitems = Signals.proxySignalDeferred<Orders.CustomerOfferItem[]>(() => (undefined) as any);
    private readonly θofferFile = Signals.proxySignalDeferred<System.BinaryData>(() => (undefined) as any);
    private readonly θofferFileId = Signals.proxySignalDeferred<System.BinaryData.Id>(() => (undefined) as any);
    private readonly θcreatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θcreatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θupdatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θupdatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θdeletedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θdeletedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θversionNumber = Signals.proxySignalDeferred<number>(() => (undefined) as any);

    static get __type(): 'Orders.CustomerOffer' {
        return 'Orders.CustomerOffer'
    }

    set __type(_) {
    }

    @jsonProperty(String)
    get __type(): 'Orders.CustomerOffer' {
        return 'Orders.CustomerOffer'
    }

    static get __baseType(): 'Orders.CustomerOffer' {
        return 'Orders.CustomerOffer'
    }

    set __baseType(_) {
    }

    get __baseType(): 'Orders.CustomerOffer' {
        return 'Orders.CustomerOffer'
    }

    get [BoInfoSymbol]() {
        return Orders__CustomerOffer[BoInfoSymbol]
    }

    get customerShippingFees(): number {
        return this.θcustomerShippingFees?.()
    }

    set customerShippingFees(customerShippingFees) {
        this.θcustomerShippingFees.set(coerceDataType(customerShippingFees, 'number', false, true))
    }

    get targetMarginPercentage(): number {
        return this.θtargetMarginPercentage?.()
    }

    set targetMarginPercentage(targetMarginPercentage) {
        this.θtargetMarginPercentage.set(coerceDataType(targetMarginPercentage, 'number', false, true))
    }

    get targetDeliveryTimeWeeks(): number {
        return this.θtargetDeliveryTimeWeeks?.()
    }

    set targetDeliveryTimeWeeks(targetDeliveryTimeWeeks) {
        this.θtargetDeliveryTimeWeeks.set(coerceDataType(targetDeliveryTimeWeeks, 'number', false, true))
    }

    get currency(): This.Currency {
        return this.θcurrency?.()
    }

    set currency(currency: This.Currency | This.Currency.Id) {
        this.θcurrency().θupdate(currency)
    }

    @jsonProperty(String)
    get 'currency$id'(): This.Currency.Id {
        return this.θcurrency?.()?.id
    }

    set 'currency$id'(currency: string) {
        this.θcurrency().θupdate(currency as This.Currency.Id)
    }

    get offerFilename(): string {
        return this.θofferFilename?.()
    }

    set offerFilename(offerFilename) {
        this.θofferFilename.set(coerceDataType(offerFilename, 'string', false, true))
    }

    get emailText(): string {
        return this.θemailText?.()
    }

    set emailText(emailText) {
        this.θemailText.set(coerceDataType(emailText, 'string', false, true))
    }

    get request(): Orders.CustomerRequest {
        return this.θrequest?.()
    }

    set request(request) {
        this.θrequest.set(coerceDataType(request, Orders.CustomerRequest, false, true))
        if (request) {
            this.θrequestId.set(request.id)
        } else if (request === null && request) {
            this.θrequestId.set(null)
        }
    }

    get requestId(): Orders.CustomerRequest.Id {
        return this.θrequestId?.()
    }

    set requestId(requestId) {
        if (requestId === null) this.θrequest.set(null)
        if (this.request?.id && requestId != this.request.id) throw new Error('Cannot set entity id to a different value than the current entity id')
        this.θrequestId.set(coerceDataType(requestId, 'Orders.CustomerRequest.Id', false, true))
    }

    get items(): Orders.CustomerOfferItem[] {
        return this.θitems?.()
    }

    set items(items) {
        this.θitems.set(coerceDataType(items, Orders.CustomerOfferItem, true, true))
        this.items?.forEach?.(item => { if (item && "offer" in item) item.offer = this as any })
    }

    get offerFile(): System.BinaryData {
        return this.θofferFile?.()
    }

    set offerFile(offerFile) {
        this.θofferFile.set(coerceDataType(offerFile, System.BinaryData, false, true))
        if (offerFile) {
            this.θofferFileId.set(offerFile.id)
        } else if (offerFile === null && offerFile) {
            this.θofferFileId.set(null)
        }
    }

    get offerFileId(): System.BinaryData.Id {
        return this.θofferFileId?.()
    }

    set offerFileId(offerFileId) {
        if (offerFileId === null) this.θofferFile.set(null)
        if (this.offerFile?.id && offerFileId != this.offerFile.id) throw new Error('Cannot set entity id to a different value than the current entity id')
        this.θofferFileId.set(coerceDataType(offerFileId, 'System.BinaryData.Id', false, true))
    }

    get createdOn(): Date {
        return this.θcreatedOn?.()
    }

    set createdOn(createdOn) {
        this.θcreatedOn.set(coerceDataType(createdOn, 'Date', false, true))
    }

    get createdBy(): System.UserIdAndName {
        return this.θcreatedBy?.()
    }

    set createdBy(createdBy) {
        this.θcreatedBy.set(coerceDataType(createdBy, 'System.UserIdAndName', false, true))
    }

    get updatedOn(): Date {
        return this.θupdatedOn?.()
    }

    set updatedOn(updatedOn) {
        this.θupdatedOn.set(coerceDataType(updatedOn, 'Date', false, true))
    }

    get updatedBy(): System.UserIdAndName {
        return this.θupdatedBy?.()
    }

    set updatedBy(updatedBy) {
        this.θupdatedBy.set(coerceDataType(updatedBy, 'System.UserIdAndName', false, true))
    }

    get deletedOn(): Date {
        return this.θdeletedOn?.()
    }

    set deletedOn(deletedOn) {
        this.θdeletedOn.set(coerceDataType(deletedOn, 'Date', false, true))
    }

    get deletedBy(): System.UserIdAndName {
        return this.θdeletedBy?.()
    }

    set deletedBy(deletedBy) {
        this.θdeletedBy.set(coerceDataType(deletedBy, 'System.UserIdAndName', false, true))
    }

    get versionNumber(): number {
        return this.θversionNumber?.()
    }

    set versionNumber(versionNumber) {
        this.θversionNumber.set(coerceDataType(versionNumber, 'number', false, true))
    }

    constructor(init?: Partial<Orders__CustomerOffer>, initOneToManyRelations = false) {
        if (initOneToManyRelations) {
            init = {
                items: [],
                ...init
            }

        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(Object.getPrototypeOf(this)))) {
            if (pd.get) Object.defineProperty(this, p, { ...pd, enumerable: true })
        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(this))) {
            if (p.startsWith('θ')) Object.defineProperty(this, p, { ...pd, enumerable: false })
        }

        untracked(() => assignCommonProperties(this, init))
        const θinitFn: any = (this as any).init
        if (typeof θinitFn == 'function') θinitFn(init)
    }

    θtoPlainObject(recursive = true, includeType = false) {
        const obj = {}

        for (const key of this.θgetPropertyNames(includeType)) {
            let value = Reflect.get(this, key) as any
            if (recursive && typeof value?.θtoPlainObject == 'function') {
                value = value.θtoPlainObject(recursive, includeType)
            }

            Reflect.set(obj, key, value)
        }

        return obj
    }

    $clone(deep: boolean = true, θcloneMap = new Map<any, any>()) {
        if (θcloneMap.has(this)) return θcloneMap.get(this)
        const clone = new Orders__CustomerOffer()
        θcloneMap.set(this, clone)
        function cloneValue(value: any) {
            if (θcloneMap.has(value)) return θcloneMap.get(value)
            if (typeof value?.$clone == "function") {
                return value.$clone(deep, θcloneMap)
            } else if (Array.isArray(value)) {
                return value.map(cloneValue)
            } else if (isSignal(value)) {
                return Signals.proxySignalDeferred(() => cloneValue(value()))
            }

            return value
        }

        if (deep) {
            for (const [key, value] of Object.entries(this)) {
                Reflect.set(clone, key, cloneValue(value))
            }

        }

        return clone
    }

    $updateFrom(source: Partial<Orders__CustomerOffer>, restrictToClass?: Class<Partial<Orders__CustomerOffer>>) {
        assignCommonProperties(this, source, { restrictToClass })
    }

    θgetPropertyNames(includeType: boolean = false) {
        const names: string[] = []
        names.push('id')
        names.push('customerShippingFees', 'targetMarginPercentage', 'targetDeliveryTimeWeeks', 'currency$id', 'offerFilename', 'emailText', 'request', 'requestId', 'items', 'offerFile', 'offerFileId', 'createdOn', 'createdBy', 'updatedOn', 'updatedBy', 'deletedOn', 'deletedBy', 'versionNumber')
        if (includeType) names.push('__type')
        return names
    }

    θcleanupBeforeSave() {
    }

    $equals(other: any): other is Orders__CustomerOffer {
        return equal(this, other)
    }
}

namespace Orders__CustomerOffer { }

export import CustomerOffer = Orders__CustomerOffer
setTimeout(() => {
    jsonProperty(() => Number)(Orders__CustomerOffer.prototype, 'customerShippingFees')
    jsonProperty(() => Number)(Orders__CustomerOffer.prototype, 'targetMarginPercentage')
    jsonProperty(() => Number)(Orders__CustomerOffer.prototype, 'targetDeliveryTimeWeeks')
    jsonProperty(() => String)(Orders__CustomerOffer.prototype, 'offerFilename')
    jsonProperty(() => String)(Orders__CustomerOffer.prototype, 'emailText')
    jsonProperty(() => Orders.CustomerRequest)(Orders__CustomerOffer.prototype, 'request')
    jsonProperty(() => Orders.CustomerRequest.Id)(Orders__CustomerOffer.prototype, 'requestId')
    jsonArrayProperty(() => Orders.CustomerOfferItem)(Orders__CustomerOffer.prototype, 'items')
    jsonProperty(() => System.BinaryData)(Orders__CustomerOffer.prototype, 'offerFile')
    jsonProperty(() => System.BinaryData.Id)(Orders__CustomerOffer.prototype, 'offerFileId')
    jsonProperty(() => Date)(Orders__CustomerOffer.prototype, 'createdOn')
    jsonProperty(() => System.UserIdAndName)(Orders__CustomerOffer.prototype, 'createdBy')
    jsonProperty(() => Date)(Orders__CustomerOffer.prototype, 'updatedOn')
    jsonProperty(() => System.UserIdAndName)(Orders__CustomerOffer.prototype, 'updatedBy')
    jsonProperty(() => Date)(Orders__CustomerOffer.prototype, 'deletedOn')
    jsonProperty(() => System.UserIdAndName)(Orders__CustomerOffer.prototype, 'deletedBy')
    jsonProperty(() => Number)(Orders__CustomerOffer.prototype, 'versionNumber')
})

export const CustomerOfferθId = Number;

export type CustomerOfferθId = number;

namespace Orders__CustomerOffer {
    export type Id = NominalType<number, 'Orders.CustomerOffer'>

}
